import { render, staticRenderFns } from "./AdminImage.vue?vue&type=template&id=265b60e8&scoped=true&"
import script from "./AdminImage.vue?vue&type=script&lang=js&"
export * from "./AdminImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "265b60e8",
  null
  
)

export default component.exports